import { useEffect, useState } from "react";

const STEPS = ["Reading PDF pages", "Detecting window & door tags", "Parsing dimension strings", "Mapping mullions & transoms", "Tagging opening types", "Building system elevations"];

export const ScannerLoader = ({ filename, progress }) => {
  const [step, setStep] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setStep((s) => Math.min(STEPS.length - 1, s + 1)), 6000);
    return () => clearInterval(t);
  }, []);
  return (
    <div className="flex-1 grid place-items-center p-8 cad-grid" data-testid="ai-scanner-loader">
      <div className="w-full max-w-md">
        <div className="relative h-56 rounded-lg border border-slate-700 bg-[#0B0F19] overflow-hidden mb-8">
          <div className="absolute inset-6 border border-slate-700 grid grid-cols-3">
            <div className="border-r border-slate-700" /><div className="border-r border-slate-700" /><div />
          </div>
          <div className="scan-line" />
        </div>
        <p className="font-mono text-xs uppercase tracking-wider text-cyan-400 mb-1">Gemini vision · extracting</p>
        <p className="font-heading text-xl font-semibold truncate mb-6">{filename}</p>
        <ul className="space-y-3">
          {STEPS.map((s, i) => (
            <li key={s} className={`flex items-center gap-3 text-sm transition-colors ${i < step ? "text-emerald-400" : i === step ? "text-slate-100" : "text-slate-600"}`}>
              <span className={`h-2 w-2 rounded-full ${i < step ? "bg-emerald-400" : i === step ? "bg-cyan-400 animate-pulse" : "bg-slate-700"}`} />{s}
            </li>
          ))}
        </ul>
        {progress?.stage && (
          <div className="mt-6 rounded-md border border-cyan-500/30 bg-cyan-500/5 p-3" data-testid="extraction-progress">
            <p className="text-sm text-cyan-200">{progress.stage}{progress.total ? ` · ${progress.done}/${progress.total}` : ""}</p>
            {progress.total > 0 && <div className="mt-2 h-1.5 rounded bg-slate-800 overflow-hidden"><div className="h-full bg-cyan-400 transition-[width] duration-500" style={{ width: `${(progress.done / progress.total) * 100}%` }} /></div>}
          </div>
        )}
        <p className="mt-6 text-xs text-slate-500">Each window/door is cropped and re-verified against its own drawing. Compiled sets can take 2–4 minutes.</p>
      </div>
    </div>
  );
};
